import React, { useRef, useEffect, useState } from "react";

import edit from "../../assets/images/icons/edit-2.png";
import trash from "../../assets/images/icons/trash.png";

const MessageSegmentItem = ({
  segment,
  handleRemoveMessageSegment,
  handleEditMessageSegment,
}) => {
  const messageSegmentRef = useRef(null);
  const [counter, setCounter] = useState(0);

  function calculateChildWidths() {
    const parentWidth = messageSegmentRef.current.offsetWidth;
    // console.log("messageSegmentRef.current", messageSegmentRef.current)
    const messageDetailsDivs = messageSegmentRef.current.querySelectorAll(
      ".individualMessageDetails"
    );
    // console.log("messageDetailsDivs", messageDetailsDivs)

    let totalWidth = 20;
    let count = 0;

    messageDetailsDivs.forEach((div) => {
      const width = div.offsetWidth;
      // console.log("width", width);
      // console.log("parentWidth", parentWidth);
      // console.log("totalWidth", totalWidth);
      const total = totalWidth + width + 20;
      // console.log("total", total);
      totalWidth = total;
      if (total > parentWidth) {
        if (count === 0) {
          totalWidth = totalWidth + 60; // 60 width for show counter
        }
        // console.log("working", total > parentWidth, total, parentWidth);
        count = count + 1;
      }
    });
    setCounter(count);
  }

  useEffect(() => {
    if (messageSegmentRef?.current && segment) {
      calculateChildWidths();
    }
  }, [messageSegmentRef]);
  const showItems = (segment?.blocks?.length || 0) - (counter + 1);

  return (
    <ul className="individualRow tableContent">
      <li className="mesageSegmentTitle">{segment.title}</li>
      <li
        className="messageSegmentBlocks customizedWraper"
        id="messagesagementListContent"
        ref={messageSegmentRef}
      >
        {/* {console.log("The total Mesage::::==>", (segment.blocks).length)} */}
        {segment.blocks.map((block, i) => {
          if (i > showItems) {
            return null;
          }
          return (
            <div className="individualMessageDetails" key={i}>
              {block}
            </div>
          );
        })}
        {counter && counter > 0 ? (
          <div className="individualMessageDetails counterInfoWrapers" onClick={() => handleEditMessageSegment(segment)}>+ {counter}</div>
        ) : (
          ""
        )}
      </li>
      <li className="messageSegmentAction">
        <a
          onClick={() => handleEditMessageSegment(segment)}
          style={{ marginRight: "20px" }}
        >
          <img height={20} alt="imagegroup" src={edit} className="actionImg" />
        </a>
        <a onClick={() => handleRemoveMessageSegment(segment._id)}>
          <img height={20} alt="imagegroup" src={trash} className="actionImg" />
        </a>
      </li>
    </ul>
  );
};

export default MessageSegmentItem;
